import type { LibraryAdapter, LibraryItem } from "./library-adapter";
export const libraryScopes = (a: LibraryAdapter) =>
  a.scopes ??
  a.customers.map((c) => ({ ...c, ownerCustomerId: null, readOnly: false }));
export const libraryRoot = (a: LibraryAdapter, id: string) =>
  (libraryScopes(a).find((s) => s.id === id)?.name ?? id) + " 전체";
export const manuscriptTarget = (i: LibraryItem) =>
  i.targetCustomerId === undefined ? i.customerId : i.targetCustomerId;
export function ManuscriptOwnership({
  item,
  provider,
}: {
  item: LibraryItem;
  provider: LibraryAdapter;
}) {
  const name = (id: string) =>
    provider.customers.find((c) => c.id === id)?.name ?? id;
  return (
    <span className="ml-ownership">
      <span>
        소유: {item.ownerCustomerId ? name(item.ownerCustomerId) : "메타크루"}
      </span>
      <span>
        대상: {manuscriptTarget(item) ? name(manuscriptTarget(item)!) : "없음"}
      </span>
    </span>
  );
}
